// Icon.js
import React from 'react';

export const ProgressArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{ width: '32px', height: '32px' }}
  >
    <g transform="translate(0.5,0.5)">
      <path
        d="M 1.6 5.4 L 25.6 5.4 L 30.4 15 L 25.6 24.6 L 1.6 24.6 L 6.4 15 Z"
        fill="rgb(241, 243, 244)"
        stroke="rgb(0, 0, 0)"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export const Pentagon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{ width: '32px', height: '32px' }}
  >
    <g transform="translate(0.5,0.5)">
      <path
        d="M 7.03 28.05 L 1.5 11.52 L 16 1.95 L 30.5 11.52 L 24.97 28.05 Z"
        fill="none"
        stroke="rgb(0, 0, 0)"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export const Diamond = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{ width: '32px', height: '32px' }}
  >
    <g transform="translate(0.5,0.5)">
      <path
        d="M 16 1 L 30 16 L 16 31 L 2 16 Z"
        fill="none"
        stroke="rgb(0, 0, 0)"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export const Box = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{ width: '32px', height: '32px' }}
  >
    <g transform="translate(0.5,0.5)">
      <rect
        x="3"
        y="3"
        width="26"
        height="26"
        fill="none"
        stroke="rgb(0, 0, 0)"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export const Label = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{ width: '32px', height: '32px' }}
  >
    <g transform="translate(0.5,0.5)">
      <rect
        x="1"
        y="7.5"
        width="30"
        height="15"
        fill="none"
        stroke="rgb(0, 0, 0)"
        strokeWidth="1.3"
      />
      <text x="16" y="17.5" textAnchor="middle" fill="#002060" fontSize="10" fontFamily="Helvetica">
        Text
      </text>
    </g>
  </svg>
);

export const DefaultUserIcon = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M8 9C9.38071 9 10.5 7.88071 10.5 6.5C10.5 5.11929 9.38071 4 8 4C6.61929 4 5.5 5.11929 5.5 6.5C5.5 7.88071 6.61929 9 8 9Z"
        fill="#002060"
      ></path>{' '}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6 10C4.80291 10 3.76957 10.7012 3.28827 11.7152C2.48151 10.6934 2 9.40294 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.40294 13.5185 10.6934 12.7117 11.7152C12.2304 10.7012 11.1971 10 10 10H6Z"
        fill="#002060"
      ></path>{' '}
    </g>
  </svg>
);

export const DefaultemailIcon = () => (
  <svg fill="#002060" width={20} height={20} version="1.1" id="Icons" viewBox="2 4 28 24">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <g>
        {' '}
        <g>
          {' '}
          <path d="M16,16.8l13.8-9.2C29.2,5.5,27.3,4,25,4H7C4.7,4,2.8,5.5,2.2,7.6L16,16.8z"></path>{' '}
        </g>{' '}
        <g>
          {' '}
          <path d="M16.6,18.8C16.4,18.9,16.2,19,16,19s-0.4-0.1-0.6-0.2L2,9.9V23c0,2.8,2.2,5,5,5h18c2.8,0,5-2.2,5-5V9.9L16.6,18.8z"></path>{' '}
        </g>{' '}
      </g>{' '}
    </g>
  </svg>
);

export const PlusIcon = () => (
  <svg viewBox="0 0 1024 1024" height="50px" width="50px" fill="#002060" stroke="#002060">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#002060"
        d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-38.4 409.6H326.4a38.4 38.4 0 1 0 0 76.8h147.2v147.2a38.4 38.4 0 0 0 76.8 0V550.4h147.2a38.4 38.4 0 0 0 0-76.8H550.4V326.4a38.4 38.4 0 1 0-76.8 0v147.2z"
      ></path>
    </g>
  </svg>
);
